import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Badge } from 'reactstrap';
import httpService from "../../../services/http.service";

const toValue = (override) => (override === null || override === undefined ? 'default' : (override ? 'enabled' : 'disabled'));

/**
 * Section « Parrainage » de la fiche utilisateur : état effectif, code, filleuls, gains et exception
 * individuelle (suivre le réglage global / activé / désactivé).
 */
const UserReferral = ({ username }) => {
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [value, setValue] = useState('default');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        let active = true;
        httpService.get(`/users/${username}/referral`)
            .then(({ data: response }) => {
                if (active) {
                    setData(response.data);
                    setValue(toValue(response.data.override));
                }
            })
            .catch(() => active && setData({ available: false }));
        return () => { active = false; };
    }, [username]);

    if (!data || data.available === false) {
        return null;
    }

    const save = async () => {
        setSaving(true);
        setError(null);
        try {
            const override = value === 'default' ? null : value === 'enabled';
            const { data: response } = await httpService.put(`/users/${username}/referral`, { override });
            setData(response.data);
        } catch (e) {
            setError(t("Enregistrement impossible."));
        } finally {
            setSaving(false);
        }
    };

    const dirty = value !== toValue(data.override);

    return (
        <div className="row clearfix">
            <div className="col-md-12">
                <div className="card">
                    <div className="header"><h2>{t("Parrainage")}</h2></div>
                    <div className="body">
                        <p className="mb-1">
                            {t('État')} :{' '}
                            {data.effective_enabled ? <Badge color="success">{t("Activé")}</Badge> : <Badge color="danger">{t("Désactivé")}</Badge>}
                            {data.override !== null && <small className="text-muted"> ({t('exception individuelle ; réglage global')} : {data.global_enabled ? t('activé') : t('désactivé')})</small>}
                        </p>
                        <p className="mb-1">{t("Code")} : <strong>{data.code || '-'}</strong></p>
                        <p className="mb-1">{t("Filleuls récompensés")} : <strong>{data.referred_count}</strong> · {t("en attente")} : <strong>{data.pending_count}</strong></p>
                        <p className="mb-2">{t("Gains de parrainage")} : <strong>{Number(data.earned_usd || 0).toFixed(2)} $</strong></p>
                        <select className="form-control form-control-sm d-inline-block w-auto mr-2" value={value} onChange={(e) => setValue(e.target.value)}>
                            <option value="default">{t("Suivre le réglage global")}</option>
                            <option value="enabled">{t("Activé (même si le global est coupé)")}</option>
                            <option value="disabled">{t("Désactivé")}</option>
                        </select>
                        <button type="button" className="btn btn-success btn-sm" disabled={!dirty || saving} onClick={save}>
                            <i className="fa fa-check"></i>{' '}
                            <span>{t("Enregistrer")}</span>
                        </button>
                        {error && <span className="text-danger ml-2">{error}</span>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserReferral;
